import React, { useState, useEffect } from "react";
import Navbar from "../components/sub-comp/Navbar.jsx";
import HeroSection from "../components/Home/Hero";
import ExplorePrograms from "../components/Home/ExplorePrograms";
import BreakingNewsUpdates from "../components/Home/BreakingNewsUpdates";
import AccreditationSection from "../components/Home/NACTEAccreditation";
import PhilosophySection from "../components/Home/PhilosophySection";
import HistorySection from "../components/Home/HistorySection";
import StatisticsSection from "../components/Home/StatisticsSection";
import PartnershipReel from "../components/Home/PartnershipReel";
import UpcomingEvents from "../components/Home/UpocmingEvents";
import CampusNews from "../components/Home/CampusNews";
import QuickDownloads from "../components/Home/QuickDownloads";
import FullScreenImage from "../components/Home/ShowcaseSection";
import FloatingDegreeIcon from "../components/Home/FloatingDegreeIcon";
import AnnouncementBanner from "../components/Home/AnnouncementBanner";
import Footer from "../components/sub-comp/MainFooter.jsx";
import FloatingSocialPanels from "../components/sub-comp/FloatingSocialPanels.jsx";
import cmsApi from "../services/cmsApi";

const COMPONENT_MAP = {
  'hero': HeroSection,
  'programs': ExplorePrograms,
  'statistics': StatisticsSection,
  'quick-downloads': QuickDownloads,
  'downloads': QuickDownloads,
  'breaking-news': BreakingNewsUpdates,
  'accreditation': AccreditationSection,
  'philosophy': PhilosophySection,
  'history': HistorySection,
  'partnership': PartnershipReel,
  'upcoming-events': UpcomingEvents,
  'events': UpcomingEvents,
  'campus-news': CampusNews,
  'showcase': FullScreenImage,
};

const FALLBACK_ORDER = [
  'hero', 'programs', 'statistics', 'quick-downloads',
  'breaking-news', 'accreditation', 'philosophy', 'history',
  'partnership', 'upcoming-events', 'campus-news',
];

function Home() {
  const [orderedTypes, setOrderedTypes] = useState(FALLBACK_ORDER);

  useEffect(() => {
    let cancelled = false;
    const loadOrder = async () => {
      try {
        const result = await cmsApi.getHomepageComponents();
        if (!cancelled && result.success && result.components?.length) {
          const sorted = result.components
            .filter(c => c.isActive !== false)
            .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
          const types = sorted.map(c => c.type);
          if (types.length) setOrderedTypes(types);
        }
      } catch (err) {
        console.warn('Failed to load homepage order, using default:', err);
      }
    };
    loadOrder();
    return () => { cancelled = true; };
  }, []);

  const rendered = new Set();
  let showcaseRendered = false;

  return (
    <div>
      <Navbar />
      <FloatingDegreeIcon />
      {orderedTypes.map((type, idx) => {
        const Component = COMPONENT_MAP[type];
        if (!Component || rendered.has(Component)) return null;
        rendered.add(Component);
        if (Component === FullScreenImage) showcaseRendered = true;
        return (
          <React.Fragment key={type + '-' + idx}>
            <Component />
            {type === 'hero' && <AnnouncementBanner />}
          </React.Fragment>
        );
      })}
      {!showcaseRendered && <FullScreenImage />}
      <Footer />
      <FloatingSocialPanels />
    </div>
  );
}

export default Home;
